3<template>
  <v-container fluid>
    <v-btn
      color="#00A9B3"
      @click.prevent="openAddTagModal()"
      fixed
      bottom
      right
      fab
      dark
    >
      <i :style="'backgroundImage: url(' + require('@/assets/icons/plus-white.svg') + '); height:56px; width:56px; backgroundRepeat: no-repeat; backgroundPosition: center; backgroundSize: 100%; '"/>
    </v-btn>
    <div v-if="tags.length > 0" class="mt-10">
      <div v-for="(tag, i) in tags" v-bind:key="tag.id">
        <ListItem
          :last="i == tags.length - 1 ? true : false"
          @click.native="tag.editable && $modal.show(`tag${tag.id}-menu-modal`)"
          >#{{ tag.name }}</ListItem
        >

        <modal
          class="menu"
          :name="`tag${tag.id}-menu-modal`"
          width="100%"
          height="auto"
        >
          <ListItem
            border="1px solid #31b9be"
            @click.native="
              $modal.hide(`tag${tag.id}-menu-modal`);
              editTag(tag);
            "
            >#{{ tag.name }} {{ $t("dash.dictionary.tags.edit") }}</ListItem
          >
          <ListItem
            last="true"
            border="1px solid #31b9be"
            @click.native="
              $modal.hide(`tag${tag.id}-menu-modal`);
              deleteTag(tag.id);
            "
            >#{{ tag.name }} {{ $t("dash.dictionary.tags.delete") }}</ListItem
          >
        </modal>
      </div>
      <modals-container @tag-edit="getTags()" />

      <TagModal :title="$t('dash.dictionary.tags.add')" @add-tag="getTags()" />
    </div>
    <div v-else>
      <p>{{ $t("dash.dictionary.tags.not-found") }}</p>
    </div>
  </v-container>
</template>

<script>
import { neoparentTags } from "@/api";
import Button from "@/page_elements/Button";
import InputField from "@/page_elements/InputField";

export default {
  name: "neoparent-tags",
  components: { Button, InputField },
  data() {
    return {
      tags: []
    };
  },
  mounted() {
    this.getTags();
  },
  methods: {
    getTags() {
      neoparentTags
        .getTags()
        .then(result => {
          this.consoleLog(result);
          this.tags = result.data.tags;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    openAddTagModal: function() {
      this.$modal.show(`add-tag-modal`);
    },
    deleteTag(tagId) {
      if (confirm(this.$t("dash.dictionary.tags.confirm-tag"))) {
        neoparentTags
          .deleteTag(tagId)
          .then(result => {
            this.consoleLog(result);
            this.tags = result.data.tags;
          })
          .catch(err => {
            this.consoleLog(err);
          });
      }
    },
    editTag(tag) {
      this.$modal.show(
        {
          template: `
            <div>
              <Button
                class="close"
                @click.native="$modal.hide($parent.name)"
                margin="10px"
                color="#31b9be"
                bgcolor="transparent"
                width="30px"
                padding="0"
                icon="close-blue"
              ></Button>
              <h3>{{ name }}</h3>
              <InputField v-model="newName" unit="#" unit-first required placeholder="Titel"></InputField>
              <LoadingButton v-if="loading"></LoadingButton>
              <Button
                v-else
                title="Bewerk tag"
                shadow="true"
                @click.native="editTag({newName, closeModal: function() {$modal.hide($parent.name)}})"
                margin="1rem 0"
              ></Button>
            </div>
          `,
          components: {
            InputField,
            Button
          },
          data: function() {
            return {
              name: tag.name,
              newName: tag.name,
              loading: false
            };
          },
          props: {
            editTag: {}
          }
        },
        {
          name: tag.name,
          editTag({ newName, closeModal }) {
            this.loading = true;
            neoparentTags
              .editTag(tag.id, { id: tag.id, name: newName })
              .then(result => {
                this.consoleLog(result);
                this.$emit("tag-edit", { newName });
                this.loading = false;
                closeModal();
              })
              .catch(err => {
                this.loading = false;
                this.consoleLog(err);
              });
          }
        },
        {
          height: "auto",
          width: "90%",
          class: "comment"
        }
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
